import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Children } from "react";
import ButtonGroup from "@mui/material/ButtonGroup";
import classnames from "classnames";
import { useStyles } from "./ButtonGroup.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ButtonGroup_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ButtonGroup_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const ButtonGroup_ButtonGroup = (t0)=>{
    const $ = c(43);
    let children;
    let className;
    let props;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== t0) {
        ({ className, children, orientation: t1, variant: t2, separated: t3, size: t4, disabled: t5 } = t0), props = _object_without_properties(t0, [
            "className",
            "children",
            "orientation",
            "variant",
            "separated",
            "size",
            "disabled"
        ]);
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = props;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else {
        children = $[1];
        className = $[2];
        props = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
        t4 = $[7];
        t5 = $[8];
    }
    const orientation = void 0 === t1 ? "horizontal" : t1;
    const variant = void 0 === t2 ? "contained" : t2;
    const separated = void 0 === t3 ? false : t3;
    const size = void 0 === t4 ? "medium" : t4;
    const disabled = void 0 === t5 ? false : t5;
    const { classes } = useStyles();
    let t6;
    if ($[9] !== children || $[10] !== classes.buttonContainedHover || $[11] !== classes.buttonSilverHover || $[12] !== classes.element || $[13] !== classes.elementContained || $[14] !== classes.elementSeparated || $[15] !== classes.elementSilver || $[16] !== separated || $[17] !== size || $[18] !== variant) {
        let t7;
        if ($[20] !== classes.buttonContainedHover || $[21] !== classes.buttonSilverHover || $[22] !== classes.element || $[23] !== classes.elementContained || $[24] !== classes.elementSeparated || $[25] !== classes.elementSilver || $[26] !== separated || $[27] !== size || $[28] !== variant) {
            t7 = (childElement)=>{
                const _childElement_props = childElement.props, { className: classNameElement } = _childElement_props, propsElement = _object_without_properties(_childElement_props, [
                    "className"
                ]);
                const buttonType = childElement.type;
                const isButton = (null == buttonType ? void 0 : buttonType.name) === "Button";
                return _object_spread_props(_object_spread({}, childElement), {
                    props: _object_spread_props(_object_spread({}, propsElement), {
                        size,
                        className: classnames(classNameElement, classes.element, "contained" === variant && classes.elementContained, "silver" === variant && classes.elementSilver, separated && classes.elementSeparated, isButton && "contained" === variant && classes.buttonContainedHover, isButton && "silver" === variant && classes.buttonSilverHover)
                    })
                });
            };
            $[20] = classes.buttonContainedHover;
            $[21] = classes.buttonSilverHover;
            $[22] = classes.element;
            $[23] = classes.elementContained;
            $[24] = classes.elementSeparated;
            $[25] = classes.elementSilver;
            $[26] = separated;
            $[27] = size;
            $[28] = variant;
            $[29] = t7;
        } else t7 = $[29];
        t6 = Children.map(children, t7);
        $[9] = children;
        $[10] = classes.buttonContainedHover;
        $[11] = classes.buttonSilverHover;
        $[12] = classes.element;
        $[13] = classes.elementContained;
        $[14] = classes.elementSeparated;
        $[15] = classes.elementSilver;
        $[16] = separated;
        $[17] = size;
        $[18] = variant;
        $[19] = t6;
    } else t6 = $[19];
    const newChildren = t6;
    const t7 = separated && classes.buttonGroupSeparated;
    const t8 = "silver" === variant && classes.buttonGroupSilver;
    const t9 = "silver" === variant && disabled && classes.buttonGroupSilverDisabled;
    const t10 = "large" === size && classes.sizeLarge;
    let t11;
    if ($[30] !== className || $[31] !== classes.buttonGroup || $[32] !== t10 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
        t11 = classnames(classes.buttonGroup, t7, t8, t9, t10, className, "aqa_button_group");
        $[30] = className;
        $[31] = classes.buttonGroup;
        $[32] = t10;
        $[33] = t7;
        $[34] = t8;
        $[35] = t9;
        $[36] = t11;
    } else t11 = $[36];
    const buttonGroupStyles = t11;
    let t12;
    if ($[37] !== buttonGroupStyles || $[38] !== disabled || $[39] !== newChildren || $[40] !== orientation || $[41] !== props) {
        t12 = /*#__PURE__*/ jsx(ButtonGroup, _object_spread_props(_object_spread({}, props), {
            className: buttonGroupStyles,
            children: newChildren,
            disabled: disabled,
            orientation: orientation,
            variant: "contained"
        }));
        $[37] = buttonGroupStyles;
        $[38] = disabled;
        $[39] = newChildren;
        $[40] = orientation;
        $[41] = props;
        $[42] = t12;
    } else t12 = $[42];
    return t12;
};
export { ButtonGroup_ButtonGroup as ButtonGroup };
